var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{ref:"deploymentContent",attrs:{"id":"deployment"}},[_c('PageTitle',{attrs:{"title":_vm.$t('blog.deployment.title'),"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-content animated fadeInRight"},[_c('Header')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }